import { Box, useMediaQuery } from "@mui/material"

import ProfileSettings from "./ProfileSettings.jsx"
import SubscriptionSettings from "./SubscriptionSettings.jsx"
import ProPromoCard from "../../../../utils/subscription/ProPromoCard.jsx"


export default function ProfileTab() {
    const isMobile = useMediaQuery('(max-width:1050px)')

    return (
        <>
            <Box sx={{
                m: 0,
                p: isMobile ? 0 : '0 2rem',
                gap: '1rem',
            }}>
                <ProfileSettings />
                <SubscriptionSettings />
            </Box>
        </>
    )
}
